export const PERMISSIONS = {
  ADMIN_PANEL_ACCESS: 'admin_panel_access',

  AUDIT_LOGS_VIEW: 'audit_logs_view',

  ORDERS_VIEW: 'orders_view',
  ORDERS_UPDATE: 'orders_update',

  DELIVERY_VIEW: 'delivery_view',
  DELIVERY_UPDATE: 'delivery_update',

  PRODUCTS_MANAGE: 'products_manage',
  CATEGORIES_MANAGE: 'categories_manage',
  BRANDS_MANAGE: 'brands_manage',

  USERS_MANAGE: 'users_manage',

  HERO_MANAGE: 'hero_manage',
  APPEARANCE_MANAGE: 'appearance_manage',
  PAGES_MANAGE: 'pages_manage',

  SHIPPING_RATES_MANAGE: 'shipping_rates_manage',
  DISCOUNTS_MANAGE: 'discounts_manage'
};

export const DEFAULT_ROLE_PERMISSIONS = {
  admin: {
    [PERMISSIONS.ADMIN_PANEL_ACCESS]: true,

    [PERMISSIONS.AUDIT_LOGS_VIEW]: true,

    [PERMISSIONS.ORDERS_VIEW]: true,
    [PERMISSIONS.ORDERS_UPDATE]: true,

    [PERMISSIONS.DELIVERY_VIEW]: true,
    [PERMISSIONS.DELIVERY_UPDATE]: true,

    [PERMISSIONS.PRODUCTS_MANAGE]: true,
    [PERMISSIONS.CATEGORIES_MANAGE]: true,
    [PERMISSIONS.BRANDS_MANAGE]: true,

    [PERMISSIONS.USERS_MANAGE]: true,

    [PERMISSIONS.HERO_MANAGE]: true,
    [PERMISSIONS.APPEARANCE_MANAGE]: true,
    [PERMISSIONS.PAGES_MANAGE]: true,

    [PERMISSIONS.SHIPPING_RATES_MANAGE]: true,
    [PERMISSIONS.DISCOUNTS_MANAGE]: true
  },

  // Keep defaults aligned with the current UI behavior:
  // - moderator: can access Orders only
  moderator: {
    [PERMISSIONS.ADMIN_PANEL_ACCESS]: true,

    [PERMISSIONS.AUDIT_LOGS_VIEW]: false,

    [PERMISSIONS.ORDERS_VIEW]: true,
    [PERMISSIONS.ORDERS_UPDATE]: true,

    [PERMISSIONS.DELIVERY_VIEW]: false,
    [PERMISSIONS.DELIVERY_UPDATE]: false,

    [PERMISSIONS.PRODUCTS_MANAGE]: false,
    [PERMISSIONS.CATEGORIES_MANAGE]: false,
    [PERMISSIONS.BRANDS_MANAGE]: false,

    [PERMISSIONS.USERS_MANAGE]: false,

    [PERMISSIONS.HERO_MANAGE]: false,
    [PERMISSIONS.APPEARANCE_MANAGE]: false,
    [PERMISSIONS.PAGES_MANAGE]: false,

    [PERMISSIONS.SHIPPING_RATES_MANAGE]: false,
    [PERMISSIONS.DISCOUNTS_MANAGE]: false
  },

  shipping: {
    [PERMISSIONS.ADMIN_PANEL_ACCESS]: true,

    [PERMISSIONS.AUDIT_LOGS_VIEW]: false,

    [PERMISSIONS.ORDERS_VIEW]: false,
    [PERMISSIONS.ORDERS_UPDATE]: false,

    [PERMISSIONS.DELIVERY_VIEW]: true,
    [PERMISSIONS.DELIVERY_UPDATE]: true,

    [PERMISSIONS.PRODUCTS_MANAGE]: false,
    [PERMISSIONS.CATEGORIES_MANAGE]: false,
    [PERMISSIONS.BRANDS_MANAGE]: false,

    [PERMISSIONS.USERS_MANAGE]: false,

    [PERMISSIONS.HERO_MANAGE]: false,
    [PERMISSIONS.APPEARANCE_MANAGE]: false,
    [PERMISSIONS.PAGES_MANAGE]: false,

    [PERMISSIONS.SHIPPING_RATES_MANAGE]: false,
    [PERMISSIONS.DISCOUNTS_MANAGE]: false
  },

  shipping_company: {
    [PERMISSIONS.ADMIN_PANEL_ACCESS]: true,

    [PERMISSIONS.AUDIT_LOGS_VIEW]: false,

    [PERMISSIONS.ORDERS_VIEW]: false,
    [PERMISSIONS.ORDERS_UPDATE]: false,

    [PERMISSIONS.DELIVERY_VIEW]: true,
    [PERMISSIONS.DELIVERY_UPDATE]: true,

    [PERMISSIONS.PRODUCTS_MANAGE]: false,
    [PERMISSIONS.CATEGORIES_MANAGE]: false,
    [PERMISSIONS.BRANDS_MANAGE]: false,

    [PERMISSIONS.USERS_MANAGE]: false,

    [PERMISSIONS.HERO_MANAGE]: false,
    [PERMISSIONS.APPEARANCE_MANAGE]: false,
    [PERMISSIONS.PAGES_MANAGE]: false,

    [PERMISSIONS.SHIPPING_RATES_MANAGE]: false,
    [PERMISSIONS.DISCOUNTS_MANAGE]: false
  }
};

export function normalizePermissionsMap(maybeMap) {
  if (!maybeMap || typeof maybeMap !== 'object') return {};
  const out = {};
  Object.keys(maybeMap).forEach((k) => {
    out[k] = !!maybeMap[k];
  });
  return out;
}

export function mergePermissionsMaps(...maps) {
  return maps.reduce((acc, m) => {
    const next = normalizePermissionsMap(m);
    Object.keys(next).forEach((k) => {
      acc[k] = next[k];
    });
    return acc;
  }, {});
}

export function hasPermission(permissions, permissionKey) {
  return !!(permissions && permissions[permissionKey]);
}
